var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"filter-label"},[_vm._v(" Cycle Type ")]),_c('div',{staticClass:"filter-options"},[_c('SACCheckbox',{attrs:{"label":"Cooling","field":"cycleType","checked":_vm.existingCycleTypes.includes('cool'),"change":() => _vm.handleSystemFilters(
        'cycleTypeFilter',
        'cool',
        !!_vm.existingCycleTypes.includes('cool'))}}),_c('SACCheckbox',{attrs:{"label":"Heating","field":"cycleType","checked":_vm.existingCycleTypes.includes('heat'),"change":() => _vm.handleSystemFilters(
        'cycleTypeFilter',
        'heat',
        !!_vm.existingCycleTypes.includes('heat'))}}),_c('SACCheckbox',{attrs:{"label":"Fan","field":"cycleType","checked":_vm.existingCycleTypes.includes('fan'),"change":() => _vm.handleSystemFilters(
        'cycleTypeFilter',
        'fan',
        !!_vm.existingCycleTypes.includes('fan'))}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }